<template>
  <v-app id="familias-visitadas" class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome do responsável familiar"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="printTableRow"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="index"
          show-expand
          class="elevation-1"
        >
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>

          <template v-slot:item.no_cidadao="{ item }">
            {{ item.no_cidadao }}
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
          </template>
          <template v-slot:item.idade="{ item }">
            {{ item.idade }}
          </template>
          <template v-slot:item.dt_ultima_visita="{ item }">
            {{ formatDate(item.dt_ultima_visita) }}
          </template>
          <template v-slot:item.dt_ultima_visita2="{ item }">
            <div v-if="item.dt_ultima_visita != null">
              {{
                differenceOfDaysBetweenTwoDates(
                  item.dt_ultima_visita,
                  ultimaAtualizacaoSincronizadorC
                )
              }}
            </div>
          </template>

          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="7">
              <table
                class="table table-interna table-interna-hemoglobina-glicada mt-3"
              >
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ item.nu_cpf }}
                    </td>
                    <td>
                      {{ item.nu_cns }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    ultimaAtualizacaoSincronizadorC: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'RESPONSÁVEL FAMILIAR',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'NASCIMENTO',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'IDADE',
          align: 'start',
          filterable: false,
          value: 'idade',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        {
          text: 'VISITADO',
          align: 'start',
          filterable: false,
          value: 'dt_ultima_visita',
        },
        {
          text: 'DIAS',
          align: 'start',
          filterable: false,
          value: 'dt_ultima_visita2',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index: index,
        ...item,
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    getPagination(options) {
      this.currentPage = options.page
    },

    printTableRow(item) {
      if (item.dt_ultima_visita != null) {
        let diff = this.differenceOfDaysBetweenTwoDates(
          item.dt_ultima_visita,
          this.ultimaAtualizacaoSincronizadorC
        )
        if (diff > 30 || item.dt_ultima_visita == null) {
          return 'table-row-color-red'
        } else {
          return 'table-row-color-green'
        }
      } else {
        return 'table-row-color-red'
      }
    },
  },
}
</script>

<style lang="scss">
#familias-visitadas .cpf-cns {
  margin-bottom: 0px;
}
#familias-visitadas .td-interna {
  border-bottom: unset;
  padding: 0 16px;
  gap: 5px;
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0px;
  gap: 20px;
  span {
    width: 195px;
    display: flex;
  }
  .div-td-interna {
    display: flex;
    /*   min-width: 67px; */
    gap: 5px;
  }

  @media screen and (max-width: 600px) {
    display: flex;
    align-items: center;
  }
  span {
    font-weight: bold;
    color: #00000099;
    font-size: 16px;
  }
}
</style>
